<template lang="html">
  <div class="glow-container d-none d-sm-none d-md-none d-lg-block" :style="{'height': `${windowHeight}px`}">
    <div
      class="glowworm"
      v-for="(val, i) in glowsArray"
      :key="`glow${i}`"
      :style="{
        'left': `${10+(i % 3 * 40)}%`,
        'top': `${i*500}px`,
      }"
    >
      <div class="glow" />
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    windowHeight: 0,
    glows: 0
  }),
  computed: {
    glowsArray() { return Array(this.glows).fill(0) },
  },
  methods: {
    onResize() { this.windowHeight = document.body.clientHeight }
  },
  mounted() {
    this.onResize();
    this.glows  = Math.round(this.windowHeight / 500);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
}
</script>

<style lang="css" scoped>
  @keyframes bobble {
    0% {
        transform: translate3d(0%, 0px, 0px);
    }
    100% {
        transform: translate3d(0%, 1500px, 0px);
    }
  }
  .glow-container {
    width: 100%;
    position: absolute;
    overflow-y: hidden;
    top: 0px;
    z-index: 0;
  }
  .glowworm {
    animation: bobble 20s infinite linear; /* 20s by default */
    position: absolute;
    width: 20px;
    /* border-width: 0;
    border-left: 1px solid black;
    moz-border-image:
     linear-gradient(to top, rgba(66, 0, 255, 0.62), rgba(0, 0, 0, 0) ) 1 100%;
    webkit-border-image:
     linear-gradient(to top, rgba(66, 0, 255, 0.62), rgba(0, 0, 0, 0) ) 1 100%;
    border-image:
     linear-gradient(to top, rgba(66, 0, 255, 0.62), rgba(0, 0, 0, 0) ) 1 100%;
    height: 500px;
    -ms-transform: translate(0px, 20px);
    transform: translate(0px, 20px); */
  }
  .glow {
    transform: translate(-50%,-50%);
    background: url(../assets/img/glow.png) no-repeat;
    background-size: contain;
    position: absolute;
    width: 40px;
    height: 40px;
    /* z-index: 2000; */
  }
</style>
